import * as React from 'react'
import { Col } from 'react-bootstrap'
import StrongColoredText from '../../../../common/StrongColoredText'

const StepInfo: React.FunctionComponent = () => {
	return (
		<Col>
			<p>
				<StrongColoredText>Step 2:</StrongColoredText> Edit the ad. Some of the elements, such as size and color
				of texts, may differ between medias. This is just a basic preview. You can use the buttons to change
				between articles, if you have imported more than one.
			</p>
			<p>Below are descriptions of each of the elements.</p>
			<p>
				<StrongColoredText size={14}>Required:</StrongColoredText>
				<br />
				<strong>Article Title:</strong> Enter an eye catching title to capture the readers' attention.
				<br />
				<strong>Advertiser Name:</strong> Enter the advertiser's name.
				<br />
				<strong>Article Description:</strong> This section must be under 120 characters long and end in a
				complete sentence. Do not end with dot dot dot (...), more than one exclamation point (!!), more than
				one question mark (??), or submit everything in CAPS.
				<br />
				<strong>Image:</strong> The minimum recommended size is 1200 x 628 pixels.
				<br />
				<strong>Call to Action:</strong> Enter a call to action e.g. Read More.
			</p>
			<p>
				<StrongColoredText size={14}>Optional:</StrongColoredText>
				<br />
				<strong>Theme:</strong> Enter the theme label, e.g. Automobile, Travel, Health, etc.
			</p>
			<p>
				<StrongColoredText>Step 3:</StrongColoredText> The more variations you have, the better your campaign
				will perform and the cheaper the price per click will be. We recommend a{' '}
				<strong>minimum of 3 variations per article.</strong>
			</p>
			<p>
				<a href="https://www.readpeak.com/readpeak-blog/how-to-use-ad/" target="_blank">
					Read More
				</a>
			</p>
		</Col>
	)
}
export default StepInfo
